<script setup lang="ts">
import { RouteRecordRaw, useRouter } from "vue-router";
import { genRouteList } from "@/utils/common";
import { ref } from "vue";

const router = useRouter();
// 设置同时只有一个子菜单打开
const uniqueOpen = ref(true);

const myRoutes = genRouteList(router.options.routes as RouteRecordRaw[]);
</script>

<template>
  <el-menu
    :router="true"
    :unique-opened="uniqueOpen"
    :default-active="router.currentRoute.value.path"
  >
    <template v-for="item in myRoutes">
      <el-sub-menu v-if="item.children && item.children.length > 0" :index="item.path">
        <template #title>
          <el-icon>
            <component :is="item.meta?.icon" />
          </el-icon>
          {{ item.meta?.title || `` }}
        </template>
        <template v-for="subMenu in item.children">
          <sub-menu :item="subMenu"></sub-menu>
        </template>
      </el-sub-menu>
      <el-menu-item :index="item.path" v-else>
        <span>{{ item.meta?.title || `` }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
